import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Box, TextField, Grid, MenuItem, Typography } from '@material-ui/core'
import { useFormik } from 'formik'
import { useStyles } from './style'
import * as yup from 'yup'
import { changePassword, getCurrentUser } from '../../AppRedux/actions/Auth'
import DisplayMessage from '../../Components/DisplayMessage'
import { accountService } from '../../Services/AccountService/AccountService'
import { utilService } from '../../Services/UtilService/UtilService'
import { timezones } from '../../utils/timezones'
import { Loader, AppButton } from '../../Components'
import { COMMON } from '../../utils/constants'
import * as messageTypes from '../../utils/messageTypes'
import Contact from '../../Components/Contact'
import Icon from '../../utils/icons'
import moment from 'moment'

let ALL = 'ALL'
let validated = false
export const debounceValidateWebsite = _.debounce(async (value, resolve) => {
  await utilService.validateWebsite(value)
    .then(validatedData => {
      validated = true
      resolve(true)
    })
    .catch(error => {
      validated = true
      resolve(false)
    })
}, 1000)
const validationSchema = yup.object({
  company_name: yup
    .string('Enter account name')
    .max(50, 'Account name must be max 50 characters')
    .required('Account name is required'),
  address: yup
    .string('Enter your address')
    .max(100, 'Address must be max 100 characters')
    .required('Address is required'),
  city: yup
    .string('Enter your city')
    .max(100, 'City must be max 100 characters')
    .required('City is required'),
  state: yup
    .string('Enter your state')
    .required('State is required'),
  country: yup
    .string('Enter your Country')
    .required('Country is required'),
  website: yup
    .string('Enter your website')
    .test("website", "Enter valid website", async (value) => {
      return new Promise((resolve) => debounceValidateWebsite(value, resolve))
    })
    .required('Website is required'),
  timezone: yup
    .string('Select timezone')
    .required('Timezone is required'),
})

function AccountsDetails(props) {
  const [openMessage, setOpenMessage] = useState()
  const [openInlineMessage, setOpenInlineMessage] = useState()
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('info')
  const [accountDetails, setAccountDetails] = useState({})
  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState({})
  const [states, setStates] = useState(props.stateList)
  const [timezones, setTimezones] = useState({})
  const [openSupport, setOpenSupport] = useState()
  const isUser = !props.isAdmin

  const classes = useStyles()

  const formik = useFormik({
    initialValues: {
      company_name: accountDetails.company_name || '',
      address: accountDetails.address || '',
      city: accountDetails.city || '',
      state: accountDetails.state || '',
      country: accountDetails.country || '',
      website: accountDetails.website || '',
      registered_as: accountDetails.registered_as || '',
      timezone: accountDetails.timezone || '',
      createdOn: accountDetails.creation_timestamp ? moment.tz(accountDetails.creation_timestamp, props.timeZone).format('DD/MM/YYYY') : '01/01/2021',
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      updateAccountDetails(values)
    },
  })

  const getAccountDetails = () => {
    const { currentUser } = props
    setLoading(true)
    let params = { account_id: currentUser.account_id }
    accountService.getAccountDetails(params)
      .then(accountData => {
        setAccountDetails(accountData.account)
      })
      .catch(error => {
        setOpenInlineMessage(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to get account details'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const updateAccountDetails = (values) => {
    const { currentUser } = props
    const { usagePlanId, deletedClientIds, clientIds, apiKey, apiAccess, gsmAccess, ...accountDetailsData } = accountDetails
    let params = { ...accountDetailsData, ...values, account_id: currentUser.account_id }
    setLoading(true)
    accountService.updateAccountDetails(params)
      .then(accountData => {
        setLoading(false)
        setOpenInlineMessage(true)
        setMessage('Information updated')
        setMessageType(messageTypes.SUCCESS)
        props.getCurrentUser()
      })
      .catch(error => {
        setLoading(false)
        setOpenInlineMessage(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to update account details'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getAllCountries = () => {
    setLoading(true)
    utilService.getAllCountries()
      .then(countriesData => {
        setCountries(countriesData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpenMessage(false)
    setOpenInlineMessage(false)
  }

  const getAllStates = (country) => {
    setLoading(true)
    utilService.getStateByCountry(country)
      .then(stateData => {
        if (_.isEmpty(stateData)) {
          setStates({ 'ALL': 'ALL' })
          formik.setFieldValue('state', 'ALL')
        } else {
          setStates(stateData)
        }
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpenInlineMessage(true)
        setMessageType(messageTypes.INFO)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to fetch states'))
      })
  }
  const getTimezones = (country) => {
    setLoading(true)
    utilService.getTimezonesByCountry(country)
      .then(timeZoneData => {
        setTimezones(timeZoneData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpenInlineMessage(true)
        setMessageType(messageTypes.INFO)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to fetch timezones'))
      })
  }
  const handleCountryChange = (e) => {
    formik.setFieldValue([e.target.name], e.target.value)
    formik.setFieldValue('state', '')
    formik.setFieldValue('timezone', '')
    getAllStates(e.target.value)
    getTimezones(e.target.value)
  }
  const renderIcon = (errors, touched) => {
    return validated ? touched ? _.isUndefined(errors) ? <Icon src="circleTick" /> : <Icon src="circleCross" /> : <></> : <></>
  }

  useEffect(() => {
    getAccountDetails()
    getAllCountries()
  }, [])

  useEffect(() => {
    if (accountDetails.country) {
      getAllStates(accountDetails.country)
      getTimezones(accountDetails.country)
    }
  }, [accountDetails.country])

  return <>
    <div>
      <Box>
        <Loader loading={loading} />
        <DisplayMessage open={openMessage} message={props.message} messageType={props.messageType} handleClose={handleMessageClose} />
        <DisplayMessage open={openInlineMessage} message={message} messageType={messageType} handleClose={handleMessageClose} />
        <Contact open={openSupport} handleClose={() => setOpenSupport(false)} />
        <Box className={classes.formContainer}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  id="accountname"
                  name="company_name"
                  label="Account Name"
                  disabled={isUser}
                  value={formik.values.company_name}
                  onChange={formik.handleChange}
                  onBlur={(e) => formik.setFieldValue('company_name', e.target.value.trim())}
                  InputProps={{
                    endAdornment: renderIcon(formik.errors.company_name, formik.touched.company_name),
                  }}
                  error={formik.touched.company_name && Boolean(formik.errors.company_name)}
                  helperText={formik.touched.company_name && formik.errors.company_name}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  id="city"
                  name="city"
                  label="City"
                  disabled={isUser}
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={(e) => formik.setFieldValue('city', e.target.value.trim())}
                  InputProps={{
                    endAdornment: renderIcon(formik.errors.city, formik.touched.city),
                  }}
                  error={formik.touched.city && Boolean(formik.errors.city)}
                  helperText={formik.touched.city && formik.errors.city}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  id="address"
                  name="address"
                  label="Address"
                  disabled={isUser}
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  onBlur={(e) => formik.setFieldValue('address', e.target.value.trim())}
                  InputProps={{
                    endAdornment: renderIcon(formik.errors.address, formik.touched.address),
                  }}
                  error={formik.touched.address && Boolean(formik.errors.address)}
                  helperText={formik.touched.address && formik.errors.address}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  id="website"
                  name="website"
                  label="Website"
                  disabled={isUser}
                  value={formik.values.website}
                  onChange={(e) => formik.setFieldValue('website', e.target.value.trim())}
                  InputProps={{
                    endAdornment: renderIcon(formik.errors.website, formik.touched.website),
                  }}
                  error={formik.touched.website && Boolean(formik.errors.website)}
                  helperText={formik.touched.website && formik.errors.website}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  style={{ textAlign: 'left' }}
                  id="country"
                  name="country"
                  label="Country"
                  disabled={isUser}
                  value={formik.values.country}
                  onChange={handleCountryChange}
                  InputProps={{
                    classes: { root: classes.input }
                  }}
                  SelectProps={{
                    MenuProps: {
                      classes: { paper: classes.paper },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }
                  }}
                  error={formik.touched.country && Boolean(formik.errors.country)}
                  helperText={formik.touched.country && formik.errors.country}
                >
                  {Object.keys(countries).map(key => (
                    <MenuItem value={key}>{countries[key]}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  style={{ textAlign: 'left' }}
                  id="state"
                  name="state"
                  label="State"
                  disabled={isUser || !formik.values.country}
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  InputProps={{
                    classes: { root: classes.input }
                  }}
                  SelectProps={{
                    MenuProps: {
                      classes: { paper: classes.paper },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }
                  }}
                  error={formik.touched.state && Boolean(formik.errors.state)}
                  helperText={formik.touched.state && formik.errors.state}
                >
                  {Object.keys(states).map(key => (
                    <MenuItem value={key}>{`${states[key]}${key !== ALL ? ' - ' + key : ''}`}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  style={{ textAlign: 'left' }}
                  id="timezone"
                  name="timezone"
                  label="Time Zone"
                  disabled={isUser || !formik.values.country}
                  value={formik.values.timezone}
                  onChange={formik.handleChange}
                  InputProps={{
                    classes: { root: classes.input }
                  }}
                  SelectProps={{
                    MenuProps: {
                      classes: { paper: classes.paper },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }
                  }}
                  error={formik.touched.timezone && Boolean(formik.errors.timezone)}
                  helperText={formik.touched.timezone && formik.errors.timezone}
                >
                  {Object.keys(timezones).map(timezone => (
                    <MenuItem value={timezone}>{timezone}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  style={{ textAlign: 'left' }}
                  select
                  disabled
                  id="register-as"
                  name="registered_as"
                  label="Register As"
                  value={formik.values.registered_as}
                  onChange={formik.handleChange}
                  InputProps={{
                    classes: { root: classes.input }
                  }}
                  SelectProps={{
                    MenuProps: {
                      classes: { paper: classes.paper },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }
                  }}
                  error={formik.touched.registered_as && Boolean(formik.errors.registered_as)}
                  helperText={formik.touched.registered_as && formik.errors.registered_as}
                >
                  <MenuItem value='aggregator'>Aggregator</MenuItem>
                  <MenuItem value='utility'>Utility</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box className={classes.createdOnKey}>Account Created On</Box>
                <Box className={classes.createdOnValue}>{formik.values.createdOn}</Box>
              </Grid>
            </Grid>
            <Box style={{ marginTop: '60px' }}>
              <p>Please <a className={classes.link} href="mailto:gridservices@enphase.com" target="_blank" rel="noopener noreferrer">contact support</a> if you have any problems with your account or you would like to cancel it.</p>
              <Typography style={{ margin: '20px 0 0' }}>
                I have consent for all enrolled sites to provide personal information to this user, and I have permission from this user to provide their personal information. Review Enphase's&nbsp;
                <a href="https://enphase.com/privacy" target="_blank" className={classes.privacyPolicy}>Privacy Policy</a>&nbsp;here.
              </Typography>
            </Box>
            <AppButton className={`${classes.button} ${classes.primaryButton}`} disabled={isUser} type="submit" text="Save Details" />
          </form>
        </Box>
      </Box>
    </div>
  </>
}

const mapStateToProps = ({ auth, programs }) => {
  const { authUser, currentUser, message, messageType, loading, isSuperAdmin, isAdmin, timeZone } = auth
  const { stateList } = programs
  return { authUser, currentUser, message, messageType, loading, stateList, isSuperAdmin, isAdmin, timeZone }
}

const mapDispatchToProps = dispatch => ({
  changePassword: payload => dispatch(changePassword(payload)),
  getCurrentUser: payload => dispatch(getCurrentUser(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(AccountsDetails)